import React, { useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem, Switch } from 'design-system';
import Text from 'design-system/Text';
import CheckBox from 'design-system/CheckBox';
const BroadbandFilterBox = ({ label, value, checkbox, onValueChange }) => {
    const [state, setState] = useState(value);
    useEffect(() => {
        onValueChange(state);
    }, [onValueChange, state]);
    const Control = checkbox ? CheckBox : Switch;
    return (<View style={styles.filterBox}>
      <Text Text-16 flex>
        {label}
      </Text>
      <Control onValueChange={(newValue) => {
            setState(newValue);
        }} value={state}/>
    </View>);
};
const styles = StyleSheet.create({
    filterBox: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: rem(16),
    },
});
export default BroadbandFilterBox;
